import { Component, OnInit, ViewChild } from '@angular/core';
import { CyclistService } from '../../../../services/cyclist.service';
import { HelpersService } from '../../../../services/helpers.service';
import { PosIntegrationService } from '../../../../services/pos-integration.service';
import { AddEditUserComponent } from '../../../modals/add-edit-user/add-edit-user.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Paginator } from 'primeng/paginator';
import { Router } from '@angular/router';
import { convertToParamMap } from '@angular/router';
import { CyclistAddressBikeComponent } from '../../../shared/cyclist-address-bike/cyclist-address-bike.component';

@Component({
  selector: 'app-cyclists',
  templateUrl: './cyclists.component.html',
  styleUrls: ['./cyclists.component.scss'],
})
export class CyclistsComponent implements OnInit {
  public partnerID: any;
  public loading: boolean = false;
  public syncing: boolean = false;
  public canSyncCustomers = false;
  public searched = false;
  public cyclists: any = [];
  public search: string = '';
  public searchedInfo: string = '';
  public page: number = 0;
  public limit: number = 15;
  public totalRecords: number = 0;
  public columns: any = [
    {
      header: this.translate.instant('general.headers.firstname'),
      field: 'Name',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.surname'),
      field: 'Surname',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.email'),
      field: 'Email',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.phone_number'),
      field: 'PhoneNumber',
      type: 'string',
    },
    //{
    //  header: this.translate.instant('general.headers.linked_to_strava'),
    //  field: 'IsStravaLinked',
    //  type: 'boolean',
    //},
    {
      header: this.translate.instant('bikeshop.referrals.referral_code'),
      field: 'ReferralCode',
      type: 'string',
    },
  ];

  @ViewChild('paginator') paginator: Paginator;

  constructor(
    private helpersService: HelpersService,
    private cyclistService: CyclistService,
    public modalService: NgbModal,
    private translate: TranslateService,
    private posIntegrationService: PosIntegrationService,
    private router: Router,
  ) {
    this.partnerID =
      router.url === '/administration/cyclists'
        ? 0
        : this.helpersService.getPartnerId();
    if (
      this.helpersService.getPartnerData() &&
      this.helpersService.getPartnerData().POSSystemID
    ) {
      var POSSystemID = this.helpersService.getPartnerData().POSSystemID;
      if (POSSystemID === 3 || POSSystemID === 6 || POSSystemID === 9 || POSSystemID === 22
        || POSSystemID === 17 || POSSystemID === 20) {
        this.canSyncCustomers = true;
      }
    }
  }

  ngOnInit() {
    //this.getCyclists();
  }

  getCyclists() {
    this.loading = true;
    this.cyclistService
      .getCyclists(this.partnerID, this.page, this.limit)
      .subscribe(
        (result) => {
          this.totalRecords = result.count;
          this.cyclists = result.cyclists.map((cyclist) => {
            return cyclist;
          });
          this.syncing = false;
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          this.syncing = false;
        },
      );
  }

  paginate(event) {
    this.page = event.page;
    this.limit = event.rows;
    this.getCyclists();
  }

  searchCyclist() {
    this.searchedInfo = this.search;
    this.searched = true;
    this.cyclists = [];
    this.page = 0;
    if (this.search === '') {
      this.limit = 15;
      setTimeout(() => {
        this.paginator.changePageToFirst({ page: 0, rows: this.limit } as any);
      }, 250);
    } else {
      this.limit = 500;
      this.loading = true;
      this.cyclistService
        .searchCyclistsV2(this.partnerID, this.page, this.limit, this.search)
        .subscribe(
          (result) => {
            if (result.count == 0) {
              var type = this.search.indexOf("@") > -1 ? "email" : this.search.startsWith("+") ? "phone" : isNaN(parseInt(this.search)) == false ? "phone" : "name";
              this.cyclistService.searchCyclistsOnPOS(this.partnerID, type, this.search)
                .subscribe((posCustomer) => {
                  if (posCustomer && posCustomer.Cyclists.length > 0) {
                    this.totalRecords = result.count;
                    this.cyclists = posCustomer.Cyclists.map((cyclist) => {
                      this.syncing = false;
                      this.loading = false;
                      return cyclist;
                    });

                    this.syncing = false;
                    this.loading = false;
                  }
                  else {
                    this.syncing = false;
                    this.loading = false;
                  }
                }, (err) => {
                  this.syncing = false;
                  this.loading = false;
                });
            }
            else {
              this.totalRecords = result.count;
              this.cyclists = result.cyclists.map((cyclist) => {
                return cyclist;
              });
              this.syncing = false;
              this.loading = false;
            }
          },
          (err) => {
            this.loading = false;
            this.syncing = false;
          },
        );
    }
  }

  clearSearch() {
    this.search = '';
    this.searched = false;
    this.searchedInfo = '';
    this.cyclists = [];

  }
  editUser(user) {

    if (user.ID == 0) {
      this.loading = true;
      this.cyclistService
        .linkCyclists(this.partnerID, user)
        .subscribe(
          (result) => {
            user = result.Data[0];
            console.log(user);
            this.syncing = false;
            this.loading = false;

            const modalRef = this.modalService.open(AddEditUserComponent, {
              size: 'lg',
              backdrop: 'static',
              windowClass: 'user-modal',
            });
            modalRef.componentInstance.partnerId = this.partnerID;
            modalRef.componentInstance.user = {...user};
            modalRef.componentInstance.cyclistView = true;
            modalRef.result.then(
              (result) => { 
                this.searchCyclist();
              },
              (onrejected) => { 
                this.searchCyclist();
              },
            );
          },
          (err) => {
            this.loading = false;
            this.syncing = false;
          },
        );
    }
    else {
      const modalRef = this.modalService.open(AddEditUserComponent, {
        size: 'lg',
        backdrop: 'static',
        windowClass: 'user-modal',
      });
      modalRef.componentInstance.partnerId = this.partnerID;
      modalRef.componentInstance.user = {...user};
      modalRef.componentInstance.cyclistView = true;
      modalRef.result.then(
        (result) => { },
        (onrejected) => { 
          this.searchCyclist();
        },
      );
    }

  }

  addNewCyclist() {
    const modalRef = this.modalService.open(CyclistAddressBikeComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.partnerId = this.partnerID;
    modalRef.componentInstance.user = {};
    modalRef.componentInstance.cyclistView = true;
    modalRef.result.then(
      (result) => { },
      (onrejected) => { },
    );
  }

  refreshPOSCustomers() {
    this.syncing = true;
    this.posIntegrationService
      .startIncrementalPOSClientSync(this.partnerID)
      .subscribe(
        (result) => {
          this.syncing = false;
          this.search = '';
          this.getCyclists();
        },
        (err) => {
          this.syncing = false;
        },
      );
  }
}
